import { TypeCommon } from "models/common";

export enum actions {
  GET_LIST_ORGANIZATION = "GET_LIST_ORGANIZATION",
  GET_USER_DETAIL = "GET_USER_DETAIL",
  RESET_USER_DATA = "RESET_USER_DATA",
}

export type ActionType = {
  type: string;
  payload: TypeCommon;
};
